<script>
export default {
  name: "PostsPage",
  setup() {
    return {};
  },
};
</script>

<template>
  <div></div>
</template>

<style scoped>

</style>